export const WHATSAPP_NUMBER =
  (import.meta.env.VITE_WHATSAPP_NUMBER as string | undefined) ?? "5516997381699";

export const WHATSAPP_MESSAGE =
  "Olá! Vim do site. Quero agendar uma consulta particular, ciente do valor a partir de R$ 600 e de que o atendimento é por acompanhamento contínuo.";

export function buildWppUrl(message: string = WHATSAPP_MESSAGE): string {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}
